/* BMS conversion rebuild v2, 8 Oct 2026.
   One small script for the cart drawer, cart page and product page:
   1. Delivery estimator by postcode (data: assets/bms-delivery-zones.json)
   2. AJAX handling for the "Email me my cart" form and the "Ask us first" enquiry form
   Everything is delegated from document, so it keeps working when Shopify re-renders the cart drawer.
   No cookies, no tracking, postcode is kept in this browser's localStorage only. */
(function () {
  'use strict';
  if (window.__bmsCro) return;
  window.__bmsCro = true;

  var SUPPORT = 'support@brisbanemarqueesales.com.au';
  var zones = null;
  var zonesPromise = null;
  var PC_KEY = 'bms_postcode_v1';

  function store(get, val) {
    try {
      if (get) return window.localStorage.getItem(PC_KEY) || '';
      window.localStorage.setItem(PC_KEY, val);
    } catch (e) { return ''; }
    return '';
  }

  function loadZones() {
    if (zones) return Promise.resolve(zones);
    if (zonesPromise) return zonesPromise;
    var url = (document.querySelector('meta[name="bms-zones-url"]') || {}).content;
    if (!url) return Promise.reject(new Error('no zones url'));
    zonesPromise = fetch(url).then(function (r) { return r.json(); }).then(function (j) { zones = j; return j; });
    return zonesPromise;
  }

  function lookup(pc) {
    var n = parseInt(pc, 10);
    for (var i = 0; i < zones.r.length; i++) {
      var r = zones.r[i];
      if (n >= parseInt(r[0], 10) && n <= parseInt(r[1], 10)) return { t: r[2], b6: r[3] };
    }
    return null;
  }

  /* 13 Oct 2026: <wbr> after the @ so a narrow phone can only wrap the address there, never mid-word. */
  function mail(label) {
    return '<a href="mailto:' + SUPPORT + '">' + (label || SUPPORT.replace('@', '@<wbr>')) + '</a>';
  }

  function list(arr) { return arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1]; }

  /* Returns { cls, html }. 13 Oct 2026: the SAME sentences as snippets/bms-delivery-check.liquid (product pages and
     /pages/delivery), naming the sizes in this cart where the product page says "this size".
     Data: t 0 free, 1 surcharge (WA and TAS metro), 2 regional, 3 remote; b6 = the 6x6m and 12x7m cannot ship as standard.
     - NT (27 Oct 2026, matches checkout): the 6x6m, 8x4m and 12x7m are $800 Remote delivery; the 12x6m is $798.
       Answered before the remote rule.
     - Remote (b6 or t 3): a freight quote for the 6x6m, 8x4m and 12x7m only.
     - WA $150 and TAS $120 on the 6x6m, 12x6m and 12x7m follow the STATE, not the tier: the Bulky profile's WA and TAS
       zones cover every postcode in the state (checked live 13 Oct 2026).
     - Regional (t 2) is free for every size; the 10x5m to a remote postcode is free, timing confirmed by email first.
     The cart keeps its Messenger link on the two quote answers (no other chat link in the drawer).
     27 Oct 2026: the bulky sizes (6x6m, 8x4m, 12x6m, 12x7m) now use RURAL and REMOTE below, not the tiers above.
     Keep both lists identical to the Vayu rule lists and to snippets/bms-delivery-check.liquid. */
  var RURAL  = '4300-4383,4400-4405,4550-4569,4571-4580,4600-4611,4614-4630,4655-4673,4676-4701,4710-4713,4720,4750-4754,4810-4815,4817-4818,5201-5214,5231-5291,5320-5400,5411-5434,5451-5680,5700-5710,5720-5732,5734,9726';
  var REMOTE = '2361,2406-2409,2627-2633,2795,2817-2818,2822,2836,2880-2899,3697-3709,3740-3741,3893-3900,4025,4183-4184,4216,4271-4275,4287,4384-4390,4406-4498,4507,4570,4581,4612-4613,4650,4674,4702-4709,4714-4746,4756-4809,4816,4819-4895,5220-5223,5301-5311,5401-5410,5440,5690,5713-5719,5733,6084,6161,6215-6799,6991,6997,7012,7017,7020,7022-7030,7054,7109-7216,7252-7470';
  function inList(l, n) {
    var parts = l.split(',');
    for (var i = 0; i < parts.length; i++) {
      var ab = parts[i].split('-'), a = parseInt(ab[0], 10), b = ab.length > 1 ? parseInt(ab[1], 10) : a;
      if (n >= a && n <= b) return true;
    }
    return false;
  }

  function answer(pc, box) {
    var z = lookup(pc);
    var n = parseInt(pc, 10);
    var FREE = { cls: 'yes', html: '<strong>Free delivery</strong> to ' + pc + '. Nothing added at checkout.' };
    if (!z) {
      return { cls: 'warn', html: 'We could not match ' + pc + '. Email ' + mail() + ' and we will confirm delivery for you.' };
    }
    /* data-bulky is "sku:qty," per bulky line (27 Oct 2026); older markup without ":qty" counts as 1. */
    var qty = {};
    (box.getAttribute('data-bulky') || '').split(',').forEach(function (e) {
      if (!e) return;
      var p = e.split(':');
      qty[p[0]] = (qty[p[0]] || 0) + (parseInt(p[1], 10) || 1);
    });
    var k84q = parseInt(box.getAttribute('data-klika84') || '0', 10) || 0;
    var heavy = box.getAttribute('data-heavy') === '1';
    var nt = n >= 800 && n <= 999;
    var chat = ' Prefer chat? <a href="https://m.me/1190898594098785" target="_blank" rel="noopener">Message us</a>.';
    /* 27 Oct 2026: follows the live checkout (Vayu Hide Shipping Methods rules + Regional/Remote rates), same lists as
       snippets/bms-delivery-check.liquid. Each bulky size has its own delivery profile with price-banded rates, so
       checkout charges once per unit (up to 3) and adds the sizes together. */
    var P = [];
    function add(sku, name, reg, rem, ntFee, ask, wa, tas) { var q = sku === '84' ? k84q : (qty[sku] || 0); if (q) P.push({ name: (q > 1 ? q + ' x ' : '') + name, q: Math.min(q, 3), reg: reg, rem: rem, nt: ntFee, ask: ask, wa: wa || 150, tas: tas || 120 }); }
    add('gaz-cpt-6x6-wh', '6x6m', 185, 800, 800, true);
    add('gaz-cpt-712', '12x7m', 340, 800, 800, true, 235, 190);
    add('84', '8x4m', 195, 800, 800, true);
    add('gaz-cpt-612', '12x6m', 285, 780, 798, false);
    if (P.length) {
      var area = inList(REMOTE, n) ? 'rem' : nt ? 'nt' : inList(RURAL, n) ? 'reg' : (n >= 6000 && n <= 6999) ? 'wa' : (n >= 7000 && n <= 7999) ? 'tas' : '';
      if (!area) return FREE;
      var total = 0;
      P.forEach(function (p) { total += p.q * p[area]; });
      var names = 'the ' + list(P.map(function (p) { return p.name; }));
      var where = area === 'rem' ? pc + ' is a remote delivery area.' : area === 'nt' ? pc + ' is in the Northern Territory.' : area === 'reg' ? 'We deliver to ' + pc + '. It is a regional delivery area.' : 'We deliver to ' + pc + '.';
      var html = where + ' Delivery for ' + names + ' is <strong>$' + total + '</strong>, added at checkout. Everything else in your cart delivers free.';
      var ask = (area === 'rem' || area === 'nt') && P.some(function (p) { return p.ask; });
      if (ask) return { cls: 'warn', html: html + ' For the 6x6m, 8x4m or 12x7m, please email ' + mail() + ' with your postcode before you order and we will confirm the delivery details for your address.' + chat };
      return { cls: 'fee', html: html };
    }
    if (heavy && z.t === 3) {
      /* 21 Oct 2026 site audit: checkout sells it free there */
      return { cls: FREE.cls, html: FREE.html + ' It is a remote area, so delivery can take longer: email ' + mail() + ' if you have a fixed event date.' };
    }
    return FREE;
  }

  function show(box, res) {
    var out = box.querySelector('[data-bms-est-out]');
    if (!out) return;
    out.className = 'bms-est__out bms-est__out--' + res.cls;
    out.innerHTML = res.html;
    out.hidden = false;
    box.setAttribute('data-state', res.cls);
    document.dispatchEvent(new CustomEvent('bms:estimate', { detail: { state: res.cls, box: box } }));
  }

  function run(box, pc, silent) {
    pc = (pc || '').replace(/\D/g, '');
    var out = box.querySelector('[data-bms-est-out]');
    if (pc.length !== 4) {
      if (!silent && out) { out.className = 'bms-est__out bms-est__out--warn'; out.textContent = 'Enter a 4-digit Australian postcode.'; out.hidden = false; }
      return;
    }
    store(false, pc);
    loadZones().then(function () { show(box, answer(pc, box)); }).catch(function () {
      if (out) { out.className = 'bms-est__out bms-est__out--warn'; out.innerHTML = 'We could not check that just now. Email ' + mail() + ' and we will confirm delivery for you.'; out.hidden = false; }
    });
  }

  function hydrate() {
    var saved = store(true);
    /* 12 Oct 2026: on /cart the postcode box sits below Secure checkout, outside the part Shopify re-renders.
       Copy the fresh cart data (bulky / heavy sizes) from the hidden span onto it, and re-check if it changed. */
    var src = document.querySelector('#main-cart-footer [data-bms-est-src]');
    if (src) {
      document.querySelectorAll('#main-cart-footer [data-bms-est]').forEach(function (box) {
        var changed = false;
        ['data-bulky', 'data-heavy', 'data-klika84'].forEach(function (a) {
          var v = src.getAttribute(a) || '';
          if ((box.getAttribute(a) || '') !== v) { box.setAttribute(a, v); changed = true; }
        });
        var inp = box.querySelector('[data-bms-est-input]');
        if (changed && box.getAttribute('data-hydrated') === '1' && inp && inp.value.replace(/\D/g, '').length === 4) run(box, inp.value, true);
      });
    }
    document.querySelectorAll('[data-bms-est]').forEach(function (box) {
      if (box.getAttribute('data-hydrated') === '1') return;
      box.setAttribute('data-hydrated', '1');
      var input = box.querySelector('[data-bms-est-input]');
      if (input && saved && !input.value) input.value = saved;
      if (saved && saved.length === 4) run(box, saved, true);
    });
    /* add the lead channel to the email-my-cart tags (plain form post, so this runs before the buyer submits) */
    try {
      var ch = (window.BMSLeadSource && window.BMSLeadSource.channel) || '';
      document.querySelectorAll('[data-bms-save-tags]').forEach(function (t) {
        if (ch && t.value.indexOf('src ') === -1) t.value += ', src ' + ch.slice(0, 40);
      });
    } catch (e) {}
    /* postcode saved on a product page prefills the enquiry forms too */
    document.querySelectorAll('[data-bms-prefill-postcode]').forEach(function (el) { if (saved && !el.value) el.value = saved; });
  }

  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-bms-est-go]');
    if (!go) return;
    var box = go.closest('[data-bms-est]');
    var input = box.querySelector('[data-bms-est-input]');
    run(box, input.value, false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-bms-est-input]');
    if (!input) return;
    e.preventDefault();
    run(input.closest('[data-bms-est]'), input.value, false);
  });



  /* ---------- Product gallery arrows (8 Oct 2026) ----------
     Bug found live and in preview: Dawn's slider arrows call slider.scrollTo({left}) and rely on CSS smooth
     scrolling; on some phones the smooth scroll never starts (no scroll event fires), so the arrow looks dead.
     We take over the click for the product gallery only: smooth scroll to the next photo, and if it has not
     moved shortly after, jump there instantly. Wraps from the last photo to the first and back. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('media-gallery .slider-button');
    if (!btn) return;
    var sc = btn.closest('slider-component');
    var list = sc && sc.querySelector('.product__media-list, [id^="Slider-Gallery"]');
    if (!list) return;
    var slides = Array.prototype.filter.call(list.children, function (li) { return li.offsetParent !== null; });
    if (slides.length < 2) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var step = slides[1].offsetLeft - slides[0].offsetLeft || list.clientWidth;
    /* fast double taps: use the slide we are already heading to, not the half-scrolled position */
    var now = Date.now();
    var cur = (list._bmsAt && now - list._bmsAt < 700) ? list._bmsIdx : Math.round(list.scrollLeft / step);
    var next = btn.name === 'previous' ? cur - 1 : cur + 1;
    if (next >= slides.length) next = 0;
    if (next < 0) next = slides.length - 1;
    var target = slides[next].offsetLeft - slides[0].offsetLeft;
    list._bmsIdx = next; list._bmsAt = now;
    var start = list.scrollLeft;
    try { list.scrollTo({ left: target, behavior: 'smooth' }); } catch (err) { list.scrollLeft = target; }
    setTimeout(function () {
      if (Math.abs(list.scrollLeft - start) < 2 && Math.abs(target - start) > 2) {
        list.style.scrollBehavior = 'auto';
        list.scrollLeft = target;
        list.style.scrollBehavior = '';
      }
      list.dispatchEvent(new Event('scroll'));
    }, 260);
  }, true);

  /* ---------- Complete your setup: add-on buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bms-xs-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = 'Adding';
    var drawer = btn.closest('cart-drawer');
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var body = { items: [{ id: Number(btn.getAttribute('data-bms-xs-add')), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (j) {
        if (drawer && j.sections && typeof drawer.renderContents === 'function') {
          j.id = j.id || (j.items && j.items[0] && j.items[0].id);
          drawer.renderContents(j);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = was; });
  });

  /* ---------- forms ---------- */
  function fillLead(form) {
    try { if (window.BMSFillLeadForm) window.BMSFillLeadForm(form); } catch (e) {}
  }

  function cartSummary() {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-bms-ajax-form]')) return;
    var consent = form.querySelector('[data-bms-consent]');
    if (consent && !consent.checked) {
      e.preventDefault();
      var msg = form.querySelector('[data-bms-form-msg]');
      if (msg) { msg.className = 'bms-form__msg bms-form__msg--err'; msg.textContent = 'Please tick the box so we know you are happy for us to email you.'; msg.hidden = false; }
      return;
    }
    if (form.getAttribute('data-sending') === '1') { e.preventDefault(); return; }
    e.preventDefault();
    form.setAttribute('data-sending', '1');
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending'; }
    var msgEl = form.querySelector('[data-bms-form-msg]');

    function done(ok, text) {
      form.removeAttribute('data-sending');
      if (btn) { btn.disabled = false; btn.textContent = label; }
      if (msgEl) { msgEl.className = 'bms-form__msg ' + (ok ? 'bms-form__msg--ok' : 'bms-form__msg--err'); msgEl.textContent = text; msgEl.hidden = false; }
      if (ok) {
        form.querySelectorAll('input[type="email"],textarea,input[type="text"]:not([data-bms-prefill-postcode])').forEach(function (i) { i.value = ''; });
        if (consent) consent.checked = false;
        document.dispatchEvent(new CustomEvent('bms:form-sent', { detail: { kind: form.getAttribute('data-bms-ajax-form') } }));
      }
    }

    var kind = form.getAttribute('data-bms-ajax-form');
    var prep = Promise.resolve();
    fillLead(form);
    if (kind === 'cart-save') {
      prep = cartSummary().then(function (cart) {
        var tags = form.querySelector('input[name="contact[tags]"]');
        var parts = ['bms-cart-reminder-consent'];
        var ch = (window.BMSLeadSource && window.BMSLeadSource.channel) || '';
        if (ch) parts.push('src ' + ch);
        if (cart && cart.items) cart.items.forEach(function (i) { parts.push('cart ' + (i.handle || '').slice(0, 50)); });
        if (tags) tags.value = parts.join(', ');
      });
    } else if (kind === 'ask') {
      prep = cartSummary().then(function (cart) {
        var f = form.querySelector('[data-bms-cart-field]');
        if (f && cart && cart.items && cart.items.length) {
          f.value = cart.items.map(function (i) { return i.quantity + ' x ' + i.product_title + ' ' + (i.variant_title && i.variant_title !== 'Default Title' ? '(' + i.variant_title + ') ' : '') + '$' + (i.final_line_price / 100).toFixed(2); }).join('; ') + ' | cart total $' + (cart.total_price / 100).toFixed(2);
        }
      });
    }
    prep.then(function () {
      return fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } });
    }).then(function (r) {
      if (r.url && /\/challenge/.test(r.url)) {
        /* Shopify asked for a human check: fall back to a normal submit so the check page can show */
        form.removeAttribute('data-bms-ajax-form');
        form.submit();
        return;
      }
      if (!r.ok) throw new Error('bad status');
      done(true, kind === 'cart-save'
        ? 'Done. We will email this cart to you. You can unsubscribe from any email.'
        : 'Thanks, we have your message. We reply by email in our support hours.');
    }).catch(function () {
      done(false, 'That did not send. Please email ' + SUPPORT + ' instead.');
    });
  });

  /* after an Email-me-my-cart post Shopify reloads the page: reopen the drawer so the thanks message is seen */
  try {
    if (/customer_posted=true/.test(location.search) && location.hash === '#BmsCartSave') {
      window.addEventListener('load', function () {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function' && d.querySelector('#BmsCartSave')) d.open();
      });
    }
  } catch (e) {}

  /* Watch only the two places Shopify re-renders (cart drawer, cart page footer), not the whole page:
     a document-wide observer cost main-thread time on every third-party DOM change during load. */
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(hydrate, 150); }
  function start() {
    schedule();
    var mo = new MutationObserver(schedule);
    ['cart-drawer', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
